// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalEligibilityFamily {
    'coInsurance'?: string;
    'deductible'?: string;
    'deductibleMet'?: string;
    'deductibleOutNetwork'?: string;
    'deductibleRemaining'?: string;
    'oop'?: string;
    'oopMet'?: string;
    'oopOutNetwork'?: string;
    'oopRemaining'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalEligibilityFamily>> = [
        {
            "name":     "coInsurance",
            "baseName": "coInsurance",
            "type":     "string"
        },
        {
            "name":     "deductible",
            "baseName": "deductible",
            "type":     "string"
        },
        {
            "name":     "deductibleMet",
            "baseName": "deductibleMet",
            "type":     "string"
        },
        {
            "name":     "deductibleOutNetwork",
            "baseName": "deductibleOutNetwork",
            "type":     "string"
        },
        {
            "name":     "deductibleRemaining",
            "baseName": "deductibleRemaining",
            "type":     "string"
        },
        {
            "name":     "oop",
            "baseName": "oop",
            "type":     "string"
        },
        {
            "name":     "oopMet",
            "baseName": "oopMet",
            "type":     "string"
        },
        {
            "name":     "oopOutNetwork",
            "baseName": "oopOutNetwork",
            "type":     "string"
        },
        {
            "name":     "oopRemaining",
            "baseName": "oopRemaining",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalEligibilityFamily.attributeTypeMap;
    }
}
